import { Component, OnInit, Input } from '@angular/core';
import { IReport } from './IReport';

@Component({
    selector: 'ef-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.css'],
    standalone: false
})
export class ReportComponent implements OnInit {

  constructor() { }

  @Input() public report: IReport;

  ngOnInit() {
  }
}
